import { initReveal } from '../common/reveal';

initReveal({ selector: '#newsletterConfirmPage [data-reveal]', threshold: 0.18 });
